import cx from 'classnames';

import { AuthButton } from '@/components/buttons/auth';
import { PageHeader } from '@/components/page-header';
import { Container } from '@/components/container';

import { useHeaderScroll } from '@/hooks/useHeaderScroll';

import css from './FixedHeader.module.scss';

export const FixedHeader = ({ isDesktop, isBlurred = false }) => {
  const { isHeaderScrolled } = useHeaderScroll();

  return (
    <div
      className={cx(css.fixedHeader, {
        [css.shadow]: isHeaderScrolled,
        [css.blurred]: isBlurred,
      })}
    >
      <Container>
        <PageHeader rightSlot={isDesktop && !isBlurred && <AuthButton />} />
      </Container>
    </div>
  );
};
